export default {"src":"/_next/static/media/address.dfde3e0f.svg","height":25,"width":20};